import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import styles from './index.styl';

export const enhance = compose(
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/common/TermsAndPolicies/enhance.js